import React from 'react';
import { PropTypes } from 'prop-types';
import Icon from '../Icons/Icon';

const SeasonsActions = ({
  isManager = false, isPlanner = false, onDelete = () => {}, onExport = () => {}, onEdit = () => {},
}) => {
  const canEdit = isManager || isPlanner;
  return (
    <div className="flex items-center space-x-9 pl-4">
      {canEdit && (
      // Edit
        (
        <button type="button" className="focus:outline-none shrink-0" onClick={onEdit}>
          <Icon name="edit" />
        </button>
        )
      )}
      {isManager && (
      // Export
        (
        <button type="button" className="focus:outline-none shrink-0" onClick={onExport}>
          <Icon name="open_in_new" />
        </button>
        )
      )}
      {isManager && (
      // Delete
        (
        <button type="button" className="focus:outline-none shrink-0" onClick={onDelete}>
          <Icon name="delete" />
        </button>
        )
      )}
    </div>
  );
};

SeasonsActions.propTypes = {
  isManager: PropTypes.bool,
  isPlanner: PropTypes.bool,
  onDelete: PropTypes.func,
  onExport: PropTypes.func,
  onEdit: PropTypes.func,
};

export default SeasonsActions;
